import React, { FC } from 'react';

import { IMerchant } from 'src/prize/types/shoppe';

import LogoComponent from '../../../../../../atoms/Logo';

import styles from './index.module.sass';

interface LogoProps {
  merchant: IMerchant;
  width?: number;
}

const Logo: FC<LogoProps> = ({ merchant: { domain, logoImageUrl, name }, width = 90 }) => (
  <LogoComponent
    className={{ container: styles.logo }}
    image={logoImageUrl}
    link={domain}
    name={name}
    width={width}
  />
);

export default Logo;
